import { useQuery } from '@tanstack/react-query';
import { dashboardService } from '@/services/dashboardService';
import { DashboardMetricsRequest } from '@/types/api';

export const useDashboard = (params: DashboardMetricsRequest) => {
  const dashboardQuery = useQuery({
    queryKey: ['dashboard', params],
    queryFn: () => dashboardService.getDashboardMetrics(params),
  });

  return {
    metrics: dashboardQuery.data,
    isLoading: dashboardQuery.isLoading,
    error: dashboardQuery.error,
    refetch: dashboardQuery.refetch,
  };
};
